import script from "./CrossConnectRemove.vue?vue&type=script&setup=true&lang=js"
export * from "./CrossConnectRemove.vue?vue&type=script&setup=true&lang=js"

import "./CrossConnectRemove.vue?vue&type=style&index=0&id=49815353&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49815353"]])

export default __exports__